export default "__VITE_ASSET__C1PLI$XG__"